/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { Copper, GlossyCeramic, GlossyPlastic, Aluminium, MattePlastic, Chrome, Gold, Rubber, TranslucentWhitePlastic, Tin, PaintedGreenMaterial, PCBGreen } from "./FluxMaterials";

export default function FluxModel(props) {
  const { nodes, materials } = useGLTF("https://static.dbldose.com/flux.glb");
  return (
    <group {...props} dispose={null}>
      <group name="microchip" position={[0.86, 0.08, 0.21]}>
        <mesh
          name="plastic"
          castShadow
          receiveShadow
          geometry={nodes.plastic.geometry}
        //   material={materials.mat_8}
          position={[-0.99, -0.1, -0.33]}
        >
            <GlossyPlastic />
        </mesh>
        <mesh
          name="chrome"
          castShadow
          receiveShadow
          geometry={nodes.chrome.geometry}
        //   material={materials.mat_7}
          position={[-0.99, -0.1, -0.33]}
        >
            <Chrome />
        </mesh>
        <mesh
          name="aluminium"
          castShadow
          receiveShadow
          geometry={nodes.aluminium.geometry}
        //   material={materials.mat_4}
          position={[-0.99, -0.1, -0.33]}
        >
            <Tin />
        </mesh>
      </group>
      <group name="transistors" position={[0.17, -0.11, -0.66]}>
        <group name="transistor" position={[-3.95, 0.21, 1.31]}>
          <mesh
            name="plastic_1"
            castShadow
            receiveShadow
            geometry={nodes.plastic_1.geometry}
            // material={materials.mat_2}
            position={[3.65, -0.12, -0.78]}
          >
            <MattePlastic />
          </mesh>
          <mesh
            name="prongs"
            castShadow
            receiveShadow
            geometry={nodes.prongs.geometry}
            // material={materials.mat_4}
            position={[3.65, -0.12, -0.78]}
          >
            <Tin />
          </mesh>
        </group>
        <group
          name="transistor1"
          position={[2.05, -0.12, -0.97]}
          rotation={[0, 0, -Math.PI]}
        >
            <mesh
                name="plastic_2"
                castShadow
                receiveShadow
                geometry={nodes.plastic_2.geometry}
                // material={materials.mat_2}
                position={[3.65, -0.12, -0.78]}
            >
            <MattePlastic /> 
          </mesh>
          <mesh
            name="prongs_1"
            castShadow
            receiveShadow
            geometry={nodes.prongs_1.geometry}
            // material={materials.mat_4}
            position={[3.65, -0.12, -0.78]}
          >
            <Tin />
          </mesh>
        </group>
        <group name="transistorB" position={[1.9, -0.09, -0.34]}>
          <mesh
            name="transistorb2"
            castShadow
            receiveShadow
            geometry={nodes.transistorb2.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
          <mesh
            name="transistorb1"
            castShadow
            receiveShadow
            geometry={nodes.transistorb1.geometry}
            // material={materials.mat_2}
          >
            <MattePlastic />            
          </mesh>
          <mesh
            name="transistorb"
            castShadow
            receiveShadow
            geometry={nodes.transistorb.geometry}
            // material={materials.mat_10}
          >
            <Rubber />
          </mesh>
        </group>
      </group>
      <group name="switch" position={[-4.72, 0.07, 0.78]}>
        <mesh
          name="switch2"
          castShadow
          receiveShadow
          geometry={nodes.switch2.geometry}
        //   material={materials.mat_4}
        >
            <Tin />
        </mesh>
        <mesh
          name="switch1"
          castShadow
          receiveShadow
          geometry={nodes.switch1.geometry}
        //   material={materials.mat_8}
        >
            <GlossyPlastic />
        </mesh>
        <mesh
          name="switch_1"
          castShadow
          receiveShadow
          geometry={nodes.switch_1.geometry}
        //   material={materials.mat_2}
        >
         <MattePlastic />   
        </mesh>
      </group>
      <group name="capcitors" position={[0.78, 0, 0.07]}>
        <group name="capacitor" position={[2.24, 0.04, 0.36]}>
          <mesh
            name="capacitor2_remesh"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh.geometry}
            // material={materials.mat_8}
            position={[0.01, 0.02, 0.04]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh.geometry}
            // material={materials.mat_5}
            position={[0.01, 0, 0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="capacitor1"
          position={[1.1, 0.04, -0.05]}
          rotation={[0.01, -0.01, 0]}
        >
          <mesh
            name="capacitor2_remesh_1"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_1.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_1"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_1.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_1"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_1.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="capacitor2"
          position={[2.4, 0.04, -1.83]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="capacitor2_remesh_2"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_2.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_2"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_2.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_2"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_2.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group name="capacitor3" position={[2.24, 0.04, -0.03]}>
          <mesh
            name="capacitor2_remesh_3"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_3.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_3"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_3.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_3"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_3.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="capacitor4"
          position={[0.91, -0.18, -1.14]}
          rotation={[Math.PI, 0, 0]}
        >
          <mesh
            name="capacitor2_remesh_4"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_4.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_4"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_4.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_4"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_4.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group name="capacitor5" position={[0.85, 0.04, -0.05]}>
          <mesh
            name="capacitor2_remesh_5"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_5.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_5"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_5.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_5"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_5.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="capacitor6"
          position={[2.82, -0.18, -1.07]}
          rotation={[Math.PI, -1.57, 0]}
        >
          <mesh
            name="capacitor2_remesh_6"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_6.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_6"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_6.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_6"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_6.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group name="capacitor7" position={[-0.87, 0.04, 1.47]}>
          <mesh
            name="capacitor2_remesh_7"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_7.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_7"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_7.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_7"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_7.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group name="capacitor8" position={[-1.63, 0.04, 1.47]}>
          <mesh
            name="capacitor2_remesh_8"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_8.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_8"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_8.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_8"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_8.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="capacitor9"
          position={[-4.87, 0.04, 0.9]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="capacitor2_remesh_9"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_9.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_9"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_9.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_9"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_9.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group name="capacitor10" position={[-0.61, 0.04, -0.31]}>
          <mesh
            name="capacitor2_remesh_10"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_10.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_10"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_10.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_10"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_10.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="capacitor11"
          position={[-4.57, 0.04, 0.27]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="capacitor2_remesh_11"
            castShadow
            receiveShadow
            geometry={nodes.capacitor2_remesh_11.geometry}
            // material={materials.mat_8}
            position={[-1.89, -0.04, -0.03]}
          >
            <GlossyPlastic />
          </mesh>
          <mesh
            name="capacitor1_remesh_11"
            castShadow
            receiveShadow
            geometry={nodes.capacitor1_remesh_11.geometry}
            // material={materials.mat_5}
            position={[-1.89, -0.04, -0.03]}
          >
            <Aluminium />
          </mesh>
          <mesh
            name="capacitor_remesh_11"
            castShadow
            receiveShadow
            geometry={nodes.capacitor_remesh_11.geometry}
            // material={materials.mat_6}
            position={[-1.89, -0.04, -0.03]}
          >
            <Copper />
          </mesh>
        </group>
      </group>
      <group name="pinHeaders" position={[1.55, 0.12, 0.89]}>
        <group name="pinHeader" position={[3.61, -0.12, -0.51]}>
          <mesh
            name="pinHeader-mat_1"
            castShadow
            receiveShadow
            geometry={nodes["pinHeader-mat_1"].geometry}
            // material={materials.mat_1}
          >
            <Gold />
          </mesh>
          <mesh
            name="pinHeader-mat_2"
            castShadow
            receiveShadow
            geometry={nodes["pinHeader-mat_2"].geometry}
            // material={materials.mat_2}
          >
            <MattePlastic />            
          </mesh>
        </group>
        <group name="smallPinHeader" position={[-3.61, 0.12, 0.51]}>
          <mesh
            name="plastic_3"
            castShadow
            receiveShadow
            geometry={nodes.plastic_3.geometry}
            // material={materials.mat_2}
            position={[1.93, -0.26, -1.53]}
          >
            <MattePlastic />            
          </mesh>
          <mesh
            name="metal"
            castShadow
            receiveShadow
            geometry={nodes.metal.geometry}
            // material={materials.mat_1}
            position={[1.93, -0.26, -1.53]}
          >
            <Gold />
          </mesh>
        </group>
      </group>
      <group name="batteryPack" position={[-0.73, -0.24, 0.6]}>
        <group name="batteryProngs" position={[4.44, -0.83, -0.2]}>
          <mesh
            name="Open_CASCADE_STEP_translator_69_1"
            castShadow
            receiveShadow
            geometry={nodes.Open_CASCADE_STEP_translator_69_1.geometry}
            // material={materials.mat_1}
            position={[-0.08, 0, 0]}
          >
            <Gold />
          </mesh>
          <mesh
            name="Open_CASCADE_STEP_translator_69_1_1"
            castShadow
            receiveShadow
            geometry={nodes.Open_CASCADE_STEP_translator_69_1_1.geometry}
            // material={materials.mat_1}
            position={[-0.02, 0, 0]}
          >
            <Gold />
          </mesh>
          <mesh
            name="Open_CASCADE_STEP_translator_69_1_2"
            castShadow
            receiveShadow
            geometry={nodes.Open_CASCADE_STEP_translator_69_1_2.geometry}
            // material={materials.mat_1}
            position={[0.03, 0, 0]}
          >
            <Gold />
          </mesh>
          <mesh
            name="Open_CASCADE_STEP_translator_69_1_3"
            castShadow
            receiveShadow
            geometry={nodes.Open_CASCADE_STEP_translator_69_1_3.geometry}
            // material={materials.mat_1}
            position={[0.07, 0, 0]}
          >
            <Gold />
          </mesh>
        </group>
        <mesh
          name="batteryholder"
          castShadow
          receiveShadow
          geometry={nodes.batteryholder.geometry}
        //   material={materials.mat_8}
          position={[0.9, -0.74, -0.2]}
        >
            <GlossyPlastic />
        </mesh>
        <mesh
          name="nub1"
          castShadow
          receiveShadow
          geometry={nodes.nub1.geometry}
        //   material={materials.mat_8}
          position={[-2.69, 0.21, 0.6]}
        >
            <GlossyPlastic />
        </mesh>
        <mesh
          name="nub2"
          castShadow
          receiveShadow
          geometry={nodes.nub2.geometry}
        //   material={materials.mat_8}
          position={[-1.86, 0.26, -1]}
        >
            <GlossyPlastic />
        </mesh>
        <mesh
          name="nub3"
          castShadow
          receiveShadow
          geometry={nodes.nub3.geometry}
        //   material={materials.mat_8}
          position={[3.66, 0.26, 0.6]}
        >
            <GlossyPlastic />
        </mesh>
      </group>
      <group name="leds" position={[-0.48, 0.07, 0.56]}>
        <group name="component" position={[0.14, 0, 0.98]}>
          <mesh
            name="plastic_4"
            castShadow
            receiveShadow
            geometry={nodes.plastic_4.geometry}
            // material={materials.mat_0}
          >
            <TranslucentWhitePlastic />
          </mesh>
          <mesh
            name="other"
            castShadow
            receiveShadow
            geometry={nodes.other.geometry}
            // material={materials.mat_9}
          >
            <PaintedGreenMaterial />
          </mesh>
          <mesh
            name="metal1"
            castShadow
            receiveShadow
            geometry={nodes.metal1.geometry}
            // material={materials.mat_1}
          >
            <Gold />
          </mesh>
        </group>
        <group name="component1" position={[-0.12, 0, 0.98]}>
          <mesh
            name="plastic_5"
            castShadow
            receiveShadow
            geometry={nodes.plastic_5.geometry}
            // material={materials.mat_0}
          >
            <TranslucentWhitePlastic />
          </mesh>
          <mesh
            name="other_1"
            castShadow
            receiveShadow
            geometry={nodes.other_1.geometry}
            // material={materials.mat_9}
          >
            <PaintedGreenMaterial />
          </mesh>
          <mesh
            name="metal1_1"
            castShadow
            receiveShadow
            geometry={nodes.metal1_1.geometry}
            // material={materials.mat_1}
          >
            <Gold />
          </mesh>
        </group>
        <group
          name="component2"
          position={[3.66, 0, -2.06]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="plastic_6"
            castShadow
            receiveShadow
            geometry={nodes.plastic_6.geometry}
            // material={materials.mat_0}
          >
            <TranslucentWhitePlastic />
          </mesh>
          <mesh
            name="other_2"
            castShadow
            receiveShadow
            geometry={nodes.other_2.geometry}
            // material={materials.mat_9}
          >
            <PaintedGreenMaterial />
          </mesh>
          <mesh
            name="metal1_2"
            castShadow
            receiveShadow
            geometry={nodes.metal1_2.geometry}
            // material={materials.mat_1}
          >
            <Gold />
          </mesh>
        </group>
        <group name="component3" position={[-3.67, 0, 0.1]}>
          <mesh
            name="plastic_7"
            castShadow
            receiveShadow
            geometry={nodes.plastic_7.geometry}
            // material={materials.mat_0}
          >
            <TranslucentWhitePlastic />
          </mesh>
          <mesh
            name="other_3"
            castShadow
            receiveShadow
            geometry={nodes.other_3.geometry}
            // material={materials.mat_9}
          >
            <PaintedGreenMaterial />
          </mesh>
          <mesh
            name="metal1_3"
            castShadow
            receiveShadow
            geometry={nodes.metal1_3.geometry}
            // material={materials.mat_1}
          >
            <Gold />
          </mesh>
        </group>
      </group>
      <group name="resistors" position={[0.28, -0.02, -0.17]}>
        <group name="resistor" position={[-3.67, 0.1, 0.51]}>
          <mesh
            name="resistor1_1"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_1.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_1"
            castShadow
            receiveShadow
            geometry={nodes.resistor_1.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group name="resistor1" position={[0.77, -0.2, -1.02]}>
          <mesh
            name="resistor1_2"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_2.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_2"
            castShadow
            receiveShadow
            geometry={nodes.resistor_2.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="resistor2"
          position={[-3.42, 0.1, 0.83]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="resistor1_3"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_3.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_3"
            castShadow
            receiveShadow
            geometry={nodes.resistor_3.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="resistor3"
          position={[2.8, -0.2, -1.46]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="resistor1_4"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_4.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_4"
            castShadow
            receiveShadow
            geometry={nodes.resistor_4.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="resistor4"
          position={[2.41, -0.2, -1.46]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="resistor1_5"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_5.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_5"
            castShadow
            receiveShadow
            geometry={nodes.resistor_5.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="resistor5"
          position={[1.41, 0.1, 0.7]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="resistor1_6"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_6.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_6"
            castShadow
            receiveShadow
            geometry={nodes.resistor_6.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group
          name="resistor6"
          position={[-0.37, 0.1, 0.57]}
          rotation={[0, 1.57, 0]}
        >
          <mesh
            name="resistor1_7"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_7.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_7"
            castShadow
            receiveShadow
            geometry={nodes.resistor_7.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group name="resistor7" position={[0.39, 0.1, 1.08]}>
          <mesh
            name="resistor1_8"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_8.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_8"
            castShadow
            receiveShadow
            geometry={nodes.resistor_8.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
        <group name="resistor8" position={[-0.31, 0.1, 0.25]}>
          <mesh
            name="resistor1_9"
            castShadow
            receiveShadow
            geometry={nodes.resistor1_9.geometry}
            // material={materials.mat_11}
          >
            <GlossyCeramic />
          </mesh>
          <mesh
            name="resistor_9"
            castShadow
            receiveShadow
            geometry={nodes.resistor_9.geometry}
            // material={materials.mat_6}
          >
            <Copper />
          </mesh>
        </group>
      </group>
      <mesh
        name="silk"
        castShadow
        receiveShadow
        geometry={nodes.silk.geometry}
        material={materials.whiteSILK}
        position={[0.45, 0.01, 0.18]}
      >
        
      </mesh>
      <mesh
        name="solderMask"
        castShadow
        receiveShadow
        geometry={nodes.solderMask.geometry}
        // material={materials.darkGreen}
        position={[0.09, 0.03, 0.16]}
      >
        <PaintedGreenMaterial />
      </mesh>
      <mesh
        name="exposedCopper"
        castShadow
        receiveShadow
        geometry={nodes.exposedCopper.geometry}
        // material={materials.mat_6}
        position={[-0.05, 0.03, 0.16]}
        scale={ .99 }
      >
        <Copper />
      </mesh>
      <mesh
        name="outlet"
        castShadow
        receiveShadow
        geometry={nodes.outlet.geometry}
        // material={materials.mat_1}
        position={[-1.97, 0.1, -1.98]}
      >
        <Gold />
      </mesh>
      <mesh
        name="board"
        castShadow
        receiveShadow
        geometry={nodes.board.geometry}
        // material={materials.mat_12}
        position={[0.17, -0.07, 0.11]}
      >
        <PCBGreen />
      </mesh>
    </group>
  );
}

useGLTF.preload("https://static.dbldose.com/flux.glb");
